import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppState, FullTableState } from "./app.reducer";

export const selectAppState = createFeatureSelector<AppState>('app');

export const selectTableState = createSelector(
    selectAppState,
    (state: AppState) => state.tableState
  );

export const selectSavedLazyLoadEvents = createSelector(
    selectAppState,
    (state: AppState) => state.savedLazyLoadEvents
  );

export const selectSavedLazyLoadEvent = (componentName: string) => createSelector(
    selectSavedLazyLoadEvents,
    (savedEvents) => savedEvents[componentName]
  );






